<div class="row">
  <div class="col-md-12">
    <h5>
      {{ 'Blocage de pays' | translate }}
    </h5>
    <p style="margin-top: 10px">{{ 'GeoblockTooltip' | translate }}</p>
    <hr />
    <div *ngIf="disabled" class="bg-blue" style="margin-bottom: 10px; margin-top: -7px">
      {{ 'SubscribeTo.advanced' | translate }}
    </div>
    <table class="blacklisted-table">
      <thead>
        <tr>
          <th class="authorized">
            {{ 'Pays autorisés' | translate }} ({{ countries.length - blockedCountries.size }})
          </th>
          <th class="blocked">{{ 'Pays bloqués' | translate }} ({{ blockedCountries.size }})</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="authorized">
            <input
              #country
              class="form-control form-control-sm"
              placeholder="{{ 'Search' | translate }}..."
              [(ngModel)]="filterUnblocked"
              type="text"
            />
          </td>
          <td class="blocked">
            <input
              #blockCountry
              class="form-control form-control-sm"
              placeholder="{{ 'Search' | translate }}..."
              [(ngModel)]="filterBlocked"
              type="text"
            />
          </td>
        </tr>
        <tr>
          <td class="authorized">
            <button (click)="blockAllCountries()" class="btn btn-mini btn-primary">
              {{ 'AjouterTout' | translate }}
            </button>
          </td>
          <td class="blocked">
            <button (click)="enableAllCountries()" class="btn btn-mini btn-primary">
              {{ 'SupprimerTout' | translate }}
            </button>
          </td>
        </tr>
        <tr>
          <td class="authorized">
            <ul class="countries custom-scrollbar">
              <li
                *ngFor="let c of countries | filter: filterUnblocked; trackByKey: 'code'"
                [hidden]="blockedCountries.has(c.code)"
                (click)="blockAvailableCountry(c.code)"
              >
                <span class="code">{{ c.code }}</span> <span class="name">{{ c.name }}</span>
              </li>
            </ul>
          </td>
          <td class="blocked">
            <ul class="countries custom-scrollbar">
              <li
                *ngFor="let c of countries | filter: filterBlocked; trackByKey: 'code'"
                [hidden]="!blockedCountries.has(c.code)"
                (click)="enableBlockCountry(c.code)"
              >
                <span class="code">{{ c.code }}</span
                ><span class="name">{{ c.name }}</span>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pull-right">
      <button
        [disabled]="provisioningInProgress"
        (click)="createBlacklistedCountries()"
        class="btn btn-sm btn-primary"
        [innerHTML]="'valider' | translate"
        style="margin-top: 10px"
      ></button>
    </div>
  </div>
</div>
